import React, { memo, useCallback, useState } from 'react';
import { getDeviceSwVersion } from 'common/utils/helpers';
import { isDeviceOnline, getDeviceLastActivityTime } from 'common/utils/deviceTwinUtils';
import classnames from 'classnames';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import BundleOverviewControllerActionIconsContainer from '../BundleOverviewControllerActionIconsContainer/BundleOverviewControllerActionIconsContainer';
import LTEDetailsModal from 'components/features/LTEDetailsModal/LTEDetailsModal';

const BundleOverviewControllerTab = (props) => {
  const [isLTEDetailsModalOpen, setIsLTEDetailsModalOpen] = useState(false);
  const triangleDiv = (
    <div className="BundleOverviewController_ArrowDown" id="BundleOverviewController_ArrowDown"></div>
  );
  const swVersion = props.isGa2 ? props.donorSwVersion : getDeviceSwVersion(props.device);
  const isOnline = isDeviceOnline(props.device);
  const lastActivityTime = getDeviceLastActivityTime(props.device);
  const closeLTEDetailsModal = useCallback(() => {
    setIsLTEDetailsModalOpen(false);
  }, []);

  return (
    <div
      id={`BundleOverviewControllerTab_${props.deviceType}_${props.id}`}
      key={props.id}
      className={classnames('BundleOverviewControllerTab', {
        BundleOverviewControllerTabFocus: props.activeIndex === props.device?.deviceId
      })}
      onClick={() => {
        props.scrollTo(props.id);
        props.sendSelectedDevice(props.device);
        props.setActiveIndex(props.device?.deviceId);
        props.setTargetDevice(props.device);
      }}
    >
      {isLTEDetailsModalOpen && <LTEDetailsModal device={props.device} onClose={closeLTEDetailsModal} />}
      {props.activeIndex === props.device?.deviceId && triangleDiv}
      <div className="BundleOverviewControllerTabDeviceLabel">
        <SvgAF
          img={
            props.deviceType === 'echo'
              ? IconLoader.icon_echo
              : props.isServiceUnit
              ? IconLoader.icon_service
              : IconLoader.icon_donor
          }
        />
        <div className="BundleOverviewControllerTabDeviceLabelId" data-tip={props.device?.deviceId}>
          {props.device?.deviceId || props.device?.id}
        </div>
      </div>
      <div className="BundleOverviewControllerTabConnectionContainer">
        <div className="BundleOverviewControllerTabConnectionBandType"></div>
        {props.device ? (
          <div
            className={classnames({
              BundleOverviewControllerTabConnectionOnline: isOnline,
              BundleOverviewControllerTabConnectionOffline: !isOnline
            })}
            data-tip={!isOnline ? `Offline since ${lastActivityTime}` : 'Online'}
            onClick={() => setIsLTEDetailsModalOpen(true)}
          >
            {isOnline ? 'ONLINE' : 'OFFLINE'}
          </div>
        ) : null}
      </div>
      <div className="BundleOverViewControllerTabBottomContainer">
        <div className="BundleOverviewControllerTabSwVersionContainer">
          <div className="BundleOverviewControllerTabSwVersionLabel">System SW Release</div>
          <div className="BundleOverviewControllerTabSwVersionValue" data-tip={swVersion}>
            {swVersion}
          </div>
        </div>
        <BundleOverviewControllerActionIconsContainer
          device={props.device}
          deviceType={props.deviceType}
          setTargetDevice={props.setTargetDevice}
          handleLockUnlockAction={props.handleLockUnlockAction}
          setIsLockUnlockModalOpen={props.setIsLockUnlockModalOpen}
          handleWiFiAction={props.handleWiFiAction}
        />
      </div>
    </div>
  );
};

export default memo(BundleOverviewControllerTab);
